import React from 'react'
import { FilterComponentProps } from 'types/filter-page'
import { Box, Flex, Slider, Text } from 'components/ds'
import { formatDuration } from '@disco/utils/time-utils'

const numberFormat = 'm:ss'
const maxDuration = 10 * 60

const DurationForm = ({
  value,
  onChange,
  operator = 'between',
}: FilterComponentProps) => {
  const start: number = value?.[0] || 0
  const end: number = !value
    ? Infinity
    : value[1] >= maxDuration
    ? Infinity
    : value[1]

  const handleChange = (newValue: number[]) => {
    const [start, end] = newValue
    const isDefault = start === 0 && (end === Infinity || end === maxDuration)
    onChange(
      isDefault ? undefined : [start, end === maxDuration ? Infinity : end],
      operator,
    )
  }

  return (
    <Flex align="center" gap="2">
      <Box width="50px">
        <Text size="2" color="gray">
          {formatDuration(start, numberFormat)}
        </Text>
      </Box>
      <Slider
        value={[start, end]}
        onValueChange={handleChange}
        max={maxDuration}
        step={30}
      />
      <Box width="50px">
        <Text size="2" color="gray">
          {end === Infinity ? '∞' : formatDuration(end, numberFormat)}
        </Text>
      </Box>
    </Flex>
  )
}

export default DurationForm
